// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__7eFWl","info":"Note_info__HsooS","note":"Note_note__18CFQ","actions":"Note_actions__1Q4mT"};